import React, { useEffect, useState } from 'react'
import AncServiceModal from '../ANC/AncServiceModal'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updatePNC } from '@store/actions/beneficiaryAction';
import { getServiceSubcategory } from './PNCServices';
import { errorLogger } from '@utils/applicationLogUtils';
import { diffBetweenTwoDays } from '@utils/commonUtils';
import dayjs from 'dayjs';
import { RootState } from '@store/reducers';
import { useSelector } from 'react-redux';
import { PNC_COMMON_CONSTANTS } from './PNCConstants';
import { getServiceDetailsUnderCurrentDate } from '@services/ancApiServices';

interface PncServiceProps {
    showModal: boolean;
    handleModalClose: () => void;
    modalContent: any;
}
const errorObj = {
  showError: false,
  errorMessage: '',
  errorField: '',
  isDisable: false
}

const PNCModal = ({showModal, handleModalClose, modalContent}: PncServiceProps) => {
  const [dynamicModalContent, setDynamicModaContent] = useState<any>(modalContent);
  const [modalError, setModalError] = useState<any>([errorObj]);
  const pregHistoryDetails = useSelector((state: RootState) => state.beneficiary.pregHistoryDetails);
  const pregnancyId = useSelector((state: RootState) => state.beneficiary.currPregnancyId);
  const beneficiaryDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails);


  const includeFacilityDetailsPage = ['pnc_mother'];
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setDynamicModaContent(modalContent);
  }, [modalContent]);

  useEffect(() => {
    handleModalError();
  },[]);

  const handleModalError = () => {
    const days = diffBetweenTwoDays(pregHistoryDetails?.pregnancy_closure_date, dayjs(), 'days');
    const pncLastPeriodEnd = 44;
    const pncEndWithCoolingPeriod = pncLastPeriodEnd + 30;
    const isPNCDisabled = days > pncEndWithCoolingPeriod;
    setModalError((prevState: any) => [
      ...prevState,
      {
        showError: false,
        errorMessage: '',
        errorField: 'PNC Services',
        isDisable: isPNCDisabled
      },
    ]);
  }

  const navigationMap: { [key: string]: { route: string; action: () => void } } = {
    'pnc_mother': {
      route: '/beneficiaries/pnc/create-pnc',
      action: () => navigate('/beneficiaries/pnc/create-pnc'),
    },
    'death_related_details':{
      route: '/beneficiaries/death/death-form', 
      action: () => navigate('/beneficiaries/death/death-form')
    },
  };

  const getServiceDetails = (subCategoryName:any) => {
    return dynamicModalContent?.data?.find((item: any) => item?.service_subcategory_name === subCategoryName);
  }

  const handleServiceItemClick = async (item: string) => {
    const serviceCode = getServiceDetails(item);
    const serviceCategoryCode = serviceCode?.service_subcategory_code;
    const serviceSubCategoryId = serviceCode?.service_subcategory_id;
    dispatch(updatePNC('currServiceSubCtgryId', serviceSubCategoryId));

    if (includeFacilityDetailsPage.filter((ele: any) => ele === serviceCategoryCode,).length > 0) {
      const { route } = navigationMap[serviceCategoryCode];
      
      try {
        let isPNCFirstVisit = false;
        const pncMetaData = await getServiceDetailsUnderCurrentDate('pnc', beneficiaryDetails[0]?.benef_id, pregnancyId, '', '');

        if (pncMetaData.data.length !== 0) {
          // PNC exists — only first visit if registered outside
          const pncDataLength = pncMetaData?.data?.length;
          if (pncDataLength === 1 && pncMetaData?.data?.[0]?.is_pregnancy_registered_outside) {
            isPNCFirstVisit = pncMetaData?.data?.[0]?.is_pregnancy_registered_outside;
          }
        } else {
          // No PNC yet — first visit unless it's a closure
          if (pregHistoryDetails?.module_code !== 'close_pregnancy' && pregHistoryDetails?.module_code !== 'auto_close_pregnancy') {
            isPNCFirstVisit = true;
          }
        }

        // CHANGE: always dispatch false — same-day detection moves to PNCFacilityDetails
        dispatch(updatePNC('pncOnSameDay', false));
        dispatch(updatePNC('isPNCFirstVisit', isPNCFirstVisit));

        const serviceDetails = { currRoute: route };
        navigate('/beneficiaries/pnc/service', { state: serviceDetails });

      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error);
      }
      return;
    } else if (Object.prototype.hasOwnProperty.call(navigationMap, serviceCategoryCode)) {
      const { route, action } = navigationMap[serviceCategoryCode];
      action();
    }
  };

  const handleBack = (item: string) => {
    if (item === 'Add Services') {
      handleModalClose();
    } else {
      setDynamicModaContent(modalContent);
    }
  }

  return (
    <div>
      <AncServiceModal
        showModal={showModal}
        onClose={handleModalClose}
        content={dynamicModalContent.content}
        modalTitle={dynamicModalContent.title}
        modalSubTitle={dynamicModalContent.subTitle}
        handleItemClick={handleServiceItemClick}
        handleBack={handleBack}
        errors={modalError}
      />      
    </div>
  )
}

export default PNCModal
